var map = {
	"./ayyykayyy.webp": 90214,
	"./benjamin.webp": 83561,
	"./cimen.webp": 87927,
	"./dominik.webp": 29496,
	"./kaden.webp": 15688,
	"./milk.webp": 20766,
	"./nightwing.webp": 44618,
	"./paco.webp": 23540,
	"./pitzer.webp": 42479,
	"./sayce.webp": 37492,
	"./svanur.webp": 43080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9795;